import { TicketStatus } from "./ticket-status";

export class TicketType {
    code: string;
    description: string;
    ticketStatuses: Array<TicketStatus>;
    hideInCreate: boolean;
    isEquipmentProcess: boolean;
    areaCategory: string;
    incidentCategory: string;
    serviceCategory: string;
    externalType: string;
    isDelivery: boolean;
    isAssignedAutomatically: boolean;
    addDeliveryBranch: boolean;
    activityClass: string;
    distributionChannel: string;
    sector: string;
    useDestinationBranch: boolean;
    loadCurrentBranch: boolean;

    constructor(code: string = "",
        description: string = "") {
        this.code = code;
        this.description = description;
        this.ticketStatuses = [];
        this.hideInCreate = false;
        this.isEquipmentProcess = false;
        this.areaCategory = "";
        this.incidentCategory = "";
        this.serviceCategory = "";
        this.externalType = "";
        this.isDelivery = false;
        this.isAssignedAutomatically = false;
        this.addDeliveryBranch = false;
        this.activityClass = "";
        this.distributionChannel = "";
        this.sector = "";
        this.useDestinationBranch = false;
        this.loadCurrentBranch = false;
    }
}